import React from 'react';
import ReactDOM from 'react-dom/client';
import 'leaflet/dist/leaflet.css';
import './styles.css';
import App from './App';

const OperationsApp = React.lazy(() => import('./OperationsApp').then(module => ({ default: module.OperationsApp })));
const PublicTrackingApp = React.lazy(() => import('./PublicTrackingApp').then(module => ({ default: module.PublicTrackingApp })));
const LandingApp = React.lazy(() => import('./LandingApp').then(module => ({ default: module.LandingApp })));
const ServiceLinkApp = React.lazy(() => import('./ServiceLinkApp').then(module => ({ default: module.ServiceLinkApp })));
const WorkDeviceApp = React.lazy(() => import('./WorkDeviceApp').then(module => ({ default: module.WorkDeviceApp })));
const PlatformAdminApp = React.lazy(() => import('./PlatformAdminApp').then(module => ({ default: module.PlatformAdminApp })));

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      window.setInterval(() => registration.update().catch(() => undefined), 60 * 60 * 1000);
    }).catch(() => undefined);
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <React.Suspense fallback={<div className="app-loading">Loading LocateMe…</div>}>
      {/*
        * The root is the public LocateMe website. The Family product lives at
        * /family: signing in is not the same as being entitled to a space, so
        * the front door has to be able to say so before it knows who you are.
        */}
      {window.location.pathname.startsWith('/platform')
        ? <PlatformAdminApp />
        : window.location.pathname.startsWith('/operations')
        ? <OperationsApp />
        : window.location.pathname.startsWith('/track')
          ? <PublicTrackingApp />
          : window.location.pathname.startsWith('/work-device')
            ? <WorkDeviceApp />
            : window.location.pathname.startsWith('/service')
              ? <ServiceLinkApp />
              : window.location.pathname.startsWith('/family')
                ? <App />
                : <LandingApp />}
    </React.Suspense>
  </React.StrictMode>
);
